














import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import DictAPI from '@/services/rest/bemob/dictionary';
import ThreePanelCondition from './three-panel-condition/three-panel-condition.vue';

@Component({
  components: {
    ThreePanelCondition
  }
})
export default class BrowserAndVersion extends Vue {
  @Prop() target: any;
  @Prop() conditions: any;

  @Emit('close')
  onClose() {}

  prefix: string = 'browser';
  data: any[] = [];
  loading: boolean = false;

  get title() {
    return this.t('Browser and version');
  }

  get name() {
    return this.t('Browsers');
  }

  get predicates() {
    return [
      {
        value: 'EQUALS',
        label: this.t('Equals')
      },
      {
        value: 'NOT_EQUALS',
        label: this.t('Not equal')
      },
      {
        value: 'LOWER_OR_EQUALS',
        label: this.t('Lower or equals')
      },
      {
        value: 'HIGHER_OR_EQUALS',
        label: this.t('Higher or equals')
      }
    ];
  }

  created() {
    this.loading = true;
    (new DictAPI()).get('browsers-v2', {}).then((browsers: any) => {
      this.data = Object.keys(browsers).map((e: any) => {
        return { name: e, selected: false, picked: false, data: browsers[e] };
      });

      this.loading = false;
    })
  }
}
